export const timePeriodsWithLabels = (t) => {
  return [
    { value: '1m', label: t('history.selectorOptions.oneMonth') },
    { value: '6m', label: t('history.selectorOptions.sixMonths') },
    { value: '12m', label: t('history.selectorOptions.oneYear') },
    { value: 'custom', label: t('history.selectorOptions.custom') }
  ]
}

export const timePeriodsWithValues = {
  '1m': { months: 1 },
  '6m': { months: 6 },
  '12m': { years: 1 },
  all: { years: 100 }
}

export const allHistoryYear = 1
